import React, { useState } from "react";
import { CardElement } from "@stripe/react-stripe-js";
import { useRouter } from "next/router";
import { Button } from "components/button";
import { sendCardDetails } from "pages/api/api_actions";
import { useThisUser } from "contexts/user-context";
import { colors } from "theme/colors";
import Swal from "sweetalert2";

declare global {
   interface Window {
      metr: any;
   }
}
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

const StripeForm = ({ stripe, elements }) => {
   let token = localStorage.getItem("token");
   let signupEmail = localStorage.getItem("signupEmail");

   const [loading, setLoading] = useState(false);
   const { dispatch } = useThisUser();

   const route = useRouter();

   const handleSubmit = async (event) => {
      setLoading(true);
      event.preventDefault();

      if (!stripe || !elements) {
         return;
      }
      const card = elements.getElement(CardElement);
      const result = await stripe.createToken(card);
      console.log(result, "result");

      if (result.error) {
         setLoading(false);
         Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${result.error.message}`,
         });
      } else {
         setLoading(false);
         dispatch({ type: "set_card_token", payload: result.token.id });

         if (window.metr) {
            window.metr("event", "conversion", {
               order_id: localStorage.getItem("signupEmail"),
               customer_id: localStorage.getItem("signupEmail"),
               amount: 300,
               currency: "USD",
               metadata: {},
            });
         }
         sendCardDetails(token, signupEmail, result.token.id, route);

         // route to step 3
         // route.push("/signup/step-3");
      }
   };

   return (
      <form onSubmit={handleSubmit}>
         <CardElement
            options={{
               iconStyle: "solid",
               hidePostalCode: false,
               style: {
                  base: {
                     iconColor: colors.main,
                     color: colors.main,
                     fontSize: "16px",
                     fontFamily: "helvetica, sans-serif",
                     fontSmoothing: "antialiased",
                     "::placeholder": {
                        color: colors.secondary,
                     },
                  },
                  invalid: {
                     color: colors.error,
                     ":focus": {
                        color: colors.secondary,
                     },
                  },
               },
            }}
         />

         <Button
            variant="primary"
            className="ripple"
            fullWidth={true}
            type="submit"
            style={{ marginTop: "4em" }}
            isLoading={loading}
         >
            {loading ? "loading...." : "Submit"}
         </Button>
         {/* <Button
            variant="outline"
            fullWidth={true}
            type="button"
            style={{ marginTop: "5px", color: "purple" }}
            onClick={() => route.push("/signup/step-3")}
         >
            Skip
         </Button> */}
      </form>
   );
};

export { StripeForm };
